"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FilterItemBody = /** @class */ (function (_super) {
    __extends(FilterItemBody, _super);
    function FilterItemBody() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FilterItemBody.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.open && this.props.open !== prevProps.open) {
            this.props.scheduleUpdate();
        }
    };
    FilterItemBody.prototype.render = function () {
        var _a = this.props, open = _a.open, placement = _a.placement, style = _a.style, innerRef = _a.innerRef, children = _a.children;
        return (react_1.default.createElement("div", { className: "dropdown " + (open ? "" : "hide"), ref: innerRef, style: style, "data-placement": placement }, children));
    };
    return FilterItemBody;
}(react_1.default.Component));
exports.default = FilterItemBody;
//# sourceMappingURL=FilterItemBody.js.map